import styled from 'styled-components'
import { colors } from '../../../styles/vars/colors.style'
import { Heading4 } from '../../../styles/vars/textStyles.style'
import { clamp } from '../../../styles/utils/conversion.style'
import { mq } from '../../../styles/vars/media-queries.style'
import { breakpoints } from '../../../styles/vars/breakpoints.style'
import { easings } from '../../../styles/vars/easings.style'

export const MapNavigationImage = styled.div`
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
`

export const MapNavigationImageInner = styled.div`
  height: 100%;
  width: 100%;

  &:before {
    background-color: ${colors.dark};
    bottom: 0;
    content: '';
    left: 0;
    opacity: ${props => (props.active ? 0.35 : 0.7)};
    position: absolute;
    right: 0;
    top: 0;
    transition: opacity 1.5s ${easings.out.quart};
    will-change: opacity;
    z-index: 2;
  }

  img {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
`

export const MapNavigationItem = styled.a`
  cursor: pointer;
  display: block;
  height: 100%;
  overflow: hidden;
  position: relative;

  ${mq.desk} {
    &:hover {
      ${MapNavigationImageInner} {
        &:before {
          opacity: ${props => (props.active ? 0.35 : 0.6)};
          transition: opacity 2s ${easings.out.quart};
        }
      }
    }
  }
`

export const MapNavigationItemText = styled.div`
  position: relative;
  z-index: 3;

  ${Heading4} {
    color: ${colors.light};
    ${clamp('font-size', 32, 32, breakpoints.desk, breakpoints.contained)};
    -webkit-font-smoothing: auto;
  }
`

export const MapNavigationItemBar = styled.div`
  background-color: ${props => props.color};
  bottom: 0;
  height: 0.5rem;
  left: 0;
  position: absolute;
  right: 0;
  transform: translateY(${props => (props.active ? 0 : `100%`)});
  transition: transform 0.4s
    ${props => (props.active ? easings.out.quart : easings.inOut.quart)};
  z-index: 3;
`
